import { connectedStore } from '../../store';
import getMultilingualIntroShown from '../selectors/get-multilingual-intro-shown';

const isMultilingualIntroShown = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return Boolean(getMultilingualIntroShown(state));
};

export default isMultilingualIntroShown;
